/**
 * "Today's voice allowance is gone" — asked for from two microphones (the composer's
 * and the note sheet's), answered by one sheet App mounts at the root (QuotaSheet).
 * A module-level flag rather than a prop threaded through NotePanel: the sheet is
 * about the ACCOUNT, and either mic may summon it.
 */
import { useSyncExternalStore } from 'react'

let open = false
const listeners = new Set<() => void>()

function set(next: boolean) {
  if (open === next) return
  open = next
  for (const l of listeners) l()
}

function subscribe(l: () => void) {
  listeners.add(l)
  return () => {
    listeners.delete(l)
  }
}

export function showQuotaPrompt(): void {
  set(true)
}

export function hideQuotaPrompt(): void {
  set(false)
}

export function useQuotaPrompt(): boolean {
  return useSyncExternalStore(subscribe, () => open, () => open)
}
